var React = require('react');

function Bolaverde (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fb5c703e-36b9-41e9-9716-2d4a396217d2{fill:#addcca;opacity:0.5;isolation:isolate;}")),React.createElement("title",{"key":1},"bolaverde"),React.createElement("g",{"id":"f0888f11-9376-4421-a2df-4c446dea0b0c","data-name":"Capa 2","key":2},React.createElement("g",{"id":"aff27c83-1e23-4425-a5f8-dd639d03f05b","data-name":"Capa 2"},React.createElement("path",{"className":"fb5c703e-36b9-41e9-9716-2d4a396217d2","d":"M770.4,190.45c52.28,144.37-134.3,72.25-313.56,187.23-109.16,70-349.3,429.26-426.21,174.18C-58.46,256.4,57.43,114.21,241.11,47.7,561.56-68.34,718.12,46.08,770.4,190.45Z"})))]);
}

Bolaverde.defaultProps = {"viewBox":"0 0 779.34 642.14"};

module.exports = Bolaverde;

Bolaverde.default = Bolaverde;
